module.exports = __webpack_public_path__ + "static/img/com_1.e3f01d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/com_1.png
// module id = yY/e
// module chunks = 0